import { useState } from '#imports';

export type PaywallTrigger = 'insufficient_credits' | 'download';

export interface PaywallRequest {
  trigger: PaywallTrigger;
  /** Where the block happened, e.g. create, music_task, song_detail. */
  surface: string;
  /** Credits the blocked action needs, when known. */
  requiredPoints?: number;
}

/** One upgrade dialog per layout; any page can open it at the moment of need. */
export function usePaywall() {
  const request = useState<PaywallRequest | null>('musicmint-paywall', () => null);
  const openPaywall = (next: PaywallRequest) => { request.value = { ...next }; };
  const closePaywall = () => { request.value = null; };
  return { request, openPaywall, closePaywall };
}
